import React, { useEffect, useRef, useState } from 'react';
import styles from './styles.module.scss';
import { headerRoutes, PATHS } from 'src/constants';
import { NavLink } from 'react-router-dom';
import { Text, Flex, Space, List, UnstyledButton, Box, Image, Group, ActionIcon } from '@mantine/core';
import { apiInstance } from 'src/services';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'src/store';
import { AlertTriangleFill, ChevronDownCircle, ChevronUpCircle } from '@geist-ui/icons';
import { numberLocalization } from 'src/helpers/numberLocalization';
import { Button } from '@common/components';
import { useDisclosure, useMediaQuery } from '@mantine/hooks';
import rightArrow from '../../assets/svg/right-arrow.svg';
import leftArrow from '../../assets/svg/left-arrow.svg';
import classNames from 'classnames';
import {   useParams ,useLocation } from 'react-router-dom';

const SideBar: React.FC = () => {
  const isLargeDevice = useMediaQuery('(max-width: 1199px)', true); 
  const [headerLinks, setHeaderLinks] = useState(headerRoutes);
  const [toggleSettings, setToggleSettings] = useState(false);
  const [drawerOpened, { toggle: toggleDrawer, close: closeDrawer }] = useDisclosure(true);
  const [sideBarWidth, seSideBarWidth] = useState('300px');
  const [t] = useTranslation('nav');
  const { metadata, paymentPlan, subscriptionScannedPages } = useAppSelector((state) => state.payment.data);
  const { selectedSiteData } = useAppSelector((state) => state.site);

  const [linkChanges , setIsLinkChanged ] = useState("linkChanges");
 
  const location = useLocation();
 
  // state for selected navigation.
  const [ selectedMainItem , setSelectedMainItem ] = useState("")
  const [ selectedNavChild , setSelectedNavChild ] = useState("")
  const firstItemFocus = useRef<HTMLAnchorElement>(null) // TODO : MAKE THE FIRST ELEMENT HAS FOCUS
 
  const navigateToPayment = (): void => {
    apiInstance.get('payment/portal').then((res) => {
      window.location = res.data.url;
    });
  };
  useEffect(() => {
    if(drawerOpened){
      seSideBarWidth('300px');
    }
    else{
      seSideBarWidth('100px');
    }
    if (selectedSiteData) {
      const links = headerRoutes.map((link) => {
        // if (link.title === 'headerRoutes.issues') {
        //   return {
        //     ...link,
        //     path: `/dashboard/${selectedSiteData?.site_id}/automated-audit?siteUUID=${selectedSiteData?.id}&pageNumber=1`,
        //   };
        // }
        if (link.title === 'headerRoutes.sitemap') {
          return {
            ...link,
            path: `/dashboard/${selectedSiteData?.label ?? selectedSiteData?.site_id }/sitemap?siteUUID=${selectedSiteData?.id}&pageNumber=1`,
          };
        }
        return link;
      });
      setIsLinkChanged(selectedSiteData?.label ?? selectedSiteData?.site_id )
      setHeaderLinks(links);
    }
    return;
  }, [drawerOpened , selectedSiteData ]);
  
  if (isLargeDevice) {
    return null;
  }
  const setToggleSettingsFunc = (event:any)=>{
    event.preventDefault();
    setToggleSettings(!toggleSettings);

    if ( firstItemFocus.current ) {
      firstItemFocus?.current?.setAttribute('tabindex', '-1');
      firstItemFocus?.current?.setAttribute('tabindex', '0');
      firstItemFocus?.current?.focus();
    }

  }

  return (
    <>
      <Box p={'16px'}  w={sideBarWidth} id="side-bar" className={styles.side_bar}>
        <nav aria-label={`${t('sideMenuNavLabel')}`}>
          <List className={styles.list} role="menu">
            {linkChanges &&
              headerLinks.map((route) => {
                return (
                  route.visible && (
                    <React.Fragment key={route.path}>
                      <List.Item
                        w={'100%'}
                        onClick={(e: any) => {
                          if (route.children) setToggleSettingsFunc(e);
                          setSelectedMainItem(route?.path + route?.title);
                          setSelectedNavChild('');
                        }}
                        aria-expanded={!!route.children && toggleSettings}
                        aria-controls={route.children ? `submenu-${route.path}` : undefined}
                        className={drawerOpened ? styles.liStyleOpen : styles.liStyle}
                        role="menuitem"
                      >
                        {route?.title === 'headerRoutes.upgrade' ? (
                          <UnstyledButton
                            aria-label={t(`${route.label}`)}
                            className={`${styles.button} ${selectedMainItem === route?.path + route?.title
                                ? styles.activeLink
                                : ''
                              } `}
                            style={{ width: '100%', margin: '0' }}
                            onClick={route.func}
                          >
                            <span className={styles.iconContainer}>
                              <route.icon aria-hidden="true" />
                            </span>
                            {drawerOpened && <span>{t(`${route.title}`)}</span>}

                            {route.children && (
                              <span
                                className={classNames(styles['iconContainer'], styles['updown'])}
                                onClick={setToggleSettingsFunc}
                                aria-hidden="true"
                              >
                                {toggleSettings ? <ChevronUpCircle /> : <ChevronDownCircle />}
                              </span>
                            )}
                          </UnstyledButton>
                        ) : (
                          <NavLink
                            to={route.path}
                            
                            className={`${styles.button} ${selectedMainItem === route?.path + route?.title
                                ? styles.activeLink
                                : ''
                              } `}
                            style={{ width: '100%' }}
                            onClick={route.func}
                            aria-label={String(t(`${route.title}`))}
                          >
                            <span className={styles.iconContainer}>
                              <route.icon aria-hidden="true" />
                            </span>
                            {drawerOpened && <span>{t(`${route.title}`)}</span>}

                            {route.children && (
                              <span
                                className={classNames(styles['iconContainer'], styles['updown'])}
                                onClick={setToggleSettingsFunc}
                                aria-hidden="true"
                              >
                                {toggleSettings ? <ChevronUpCircle /> : <ChevronDownCircle />}
                              </span>
                            )}
                          </NavLink>
                        )}
                      </List.Item>

                      {route.children && (
                        <List
                          className={styles.childlist}
                          display={toggleSettings ? 'block' : 'none'}
                          id={`submenu-${route.path}`}
                          role="menu"
                          aria-label={String(t(`${route.title} Submenu`))}
                        >
                          {route.children.map((child: any, index:number) => {


                            return (
                              <List.Item
                                 
                                onClick={() => {
                                  setSelectedMainItem(route?.path + route?.title);
                                  setSelectedNavChild(child?.path + child?.title);
                                }}
                                key={child.path}
                                w={'100%'}
                                className={drawerOpened ? styles.liStyleOpen : styles.liStyle}
                                role="menuitem"
                              >
                                <NavLink
                                  ref={ index ==  0 ? firstItemFocus : null}
                                  to={child.path}
                                  aria-label={String(t(`${child.title}`))}
                                  className={`${styles.button} ${styles.linksChildren}  ${selectedNavChild === child?.path + child?.title
                                      ? styles.activeLink
                                      : ''
                                    }`}
                                >
                                  <span className={styles.iconContainer}>
                                    <child.icon aria-hidden="true" />
                                  </span>
                                  {drawerOpened && <span>{t(`${child.title}`)}</span>}
                                </NavLink>
                              </List.Item>
                            );
                          })}
                        </List>
                      )}
                    </React.Fragment>
                  )
                );
              })}
          </List>

          {/* {
            drawerOpened &&
            <Flex className={styles.upgradeContainer} mt={'32px'} gap={'7px'}  align="left" wrap={'wrap'} direction={'column'}>
                  <div >
                      <UnstyledButton
                        display={'inline'}
                        className={styles.link}
                        onClick={() => {
                          navigateToPayment();
                        }}>
                        {t(`subPlans.${paymentPlan}`)}
                      </UnstyledButton>
                      <Text id="myPlan" display={'inline'}>{t('myPlan')}:</Text>
                      {subscriptionScannedPages > (+metadata.pageScansPerMonth * 90) / 100 && (
                        <AlertTriangleFill color="#A80000" stroke="#FFFFFF" aria-label={`${t('planAlert')}`} />
                      )}
                      <Text display={'inline'}>
                        {numberLocalization(subscriptionScannedPages ?? 0)}/
                        {numberLocalization(Number(metadata.pageScansPerMonth))} {t('pagesScanned')}
                      </Text>
                      <Space w={15} />
                  </div>
                  <div>
                      <Button className={styles.upgradeBtn} fullWidth onClick={()=>{ navigateToPayment(); }}>
                          {t('upgrade')}
                      </Button>
                  </div>
            </Flex>
          } */}
        </nav>
        {/* <Group position="center" className={styles.burgerMenuContainer} left={ drawerOpened ? '175px' : '85px'}>
          <ActionIcon
            variant="default"
            size="sm"
            aria-label={t(`toggleMenuSidebar`)}
            gradient={{ from: 'blue', to: 'cyan', deg: 90 }}
            onClick={toggleDrawer}
            role='buttom'
            style={{border:'0',backgroundColor:'#5b5eff'}}
          >
              <Image width={30} src={ drawerOpened ? leftArrow : rightArrow} alt={t(``) ?? undefined} />
          </ActionIcon>
        </Group> */}
      </Box>
        
    </>
  );
};
export default SideBar;